import { useEffect, useState } from "react";
import { slider_images } from "../../Assets/assests";
import HeroSlider from "../../components/user/Home/HeroSlider";
import PopUpForm from "../../components/user/Modal/PopUpForm";
import AFSAGoals from "../../components/user/NewHome/AFSAGoals";
import AFSANumbers from "../../components/user/NewHome/AFSANumbers";
import AFSAProgrammes from "../../components/user/NewHome/AFSAProgrammes";
import AFSATestimonials from "../../components/user/NewHome/AFSATestimonials";
import AFSAVolunteers from "../../components/user/NewHome/AFSAVolunteers";
import Certifications from "../../components/user/NewHome/Certifications";
import InvestmentInHumanity from "../../components/user/NewHome/InvestmentInHumanity";
import OverView from "../../components/user/NewHome/OverView";
import SpecialCampaign from "../../components/user/NewHome/SpecialCampaign";
// import AFSABlogs from "../../components/user/NewHome/AFSABlogs";
// import AFSATeam from "../../components/user/NewHome/AFSATeam";

const NewHome = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    const hasSeenPopup = sessionStorage.getItem("popupShown");

    if (!hasSeenPopup) {
      setIsPopupOpen(true);
      sessionStorage.setItem("popupShown", "true");
    }
  }, []);

  return (
    <div className="flex flex-col gap-y-2 md:gap-y-4 overflow-x-hidden">
      <PopUpForm isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />

      <section id="slider">
        {/* <Slider slides={slider_images} /> */}
        <HeroSlider slides={slider_images} />
      </section>

      <section id="overview">
        <OverView />
      </section>

      <section>
        <SpecialCampaign />
      </section>

      <section id="aafsa-in-numbers">
        <AFSANumbers />
      </section>

      <section id="programmes">
        <AFSAProgrammes />
      </section>

      <section id="goals">
        <AFSAGoals />
      </section>

      {/* <section id="our-team">
        <AFSATeam/>
      </section> */}

      <section id="volunteer">
        <AFSAVolunteers />
      </section>

      <section id="blogs-and-events ">{/* <AFSABlogs /> */}</section>

      <section id="testimonials">
        <AFSATestimonials />
      </section>

      <section id="investment-in-humanity">
        <InvestmentInHumanity />
      </section>

      <section id="certifications">
        <Certifications />
      </section>
    </div>
  );
};

export default NewHome;
